<template>
  <div>
    <div class="d-flex search-field-box align-start">
      <div :class="['field-group full-width add-limit', {active:highlight.active==='pickup'}]">
        <location-input :value="pickup" :extra="pickupExtra" ref="pickup"
          :disabled="buttonLoading || quickQuoteCheck" :error="validation.pickup" leg="leg1"
          @change="locationNewValue" @submit="triggerClickSubmit"
          @nextFocus="nextHighlight" @clickFocus="highlight.active = 'pickup'"
        ></location-input>
      </div>

      <div class="reverse-loc-box">
        <i :class="['fas fa-exchange-alt reverse-loc', {disabled:quickQuoteCheck}]" @click="reverseLoc"></i>
      </div>

      <div :class="['field-group full-width add-limit', {active:highlight.active==='dropoff'}]">
        <location-input :value="dropoff" :extra="dropoffExtra" ref="dropoff"
          :disabled="buttonLoading || quickQuoteCheck" :error="validation.dropoff" leg="leg1"
          @change="locationNewValue" @submit="triggerClickSubmit" 
          @nextFocus="nextHighlight" @clickFocus="highlight.active = 'dropoff'"
        ></location-input>
      </div>

      <div :class="['field-group date-input', {'field-error':!!d2dValidation.date, active:highlight.active==='date'}]" v-show="flightEnable">
        <input type="text" @click="openDeparturePicker" :disabled="buttonLoading || !flightEnable"
          :class="['field-text', {disabled:buttonLoading || !flightEnable}]" placeholder="Select Date"
          v-model="departureDate" ref="departure" readonly />
        <span class="field-error-message">{{ d2dValidation.date }}</span>
      </div>

      <div :class="['field-group', {active:highlight.active==='pax'}]" v-show="flightEnable && false">
        <input type="text" @click="openTravellersModal" :disabled="buttonLoading || !flightEnable"
          :class="['field-text', {disabled:buttonLoading || !flightEnable}]" placeholder="Select Date"
          :value="`${filters.travellers.total} Traveler(s)`" ref="departure" readonly />
      </div>

      <a href="#/d2dservice" @click="submit($event)" ref="quoteBtn"
        :class="['op-btn btn-md btn-black search-submit', {'disabled':buttonLoading || quickQuoteCheck || !flightEnable, active:highlight.active==='search' & !buttonLoading}]"
      >
      <span v-if="quickQuoteCheck"><i class="fa fa-spinner fa-spin"></i> Searching</span>
        <span v-else-if="!buttonLoading">Search</span>
        <span v-else><i class="fa fa-spinner fa-spin"></i> Searching</span>
      </a>
    </div>

    <travellers-modal @submit="submit"></travellers-modal>
  </div>
</template>

<script>
/* global CONFIG */
const request = require('browser-request')
import moment from 'moment'
import LocationInput from '../LocationInput'
import TravellersModal from '../TravellersModal'
import trackError from '@/modules/api/track-error'
import booking from '@/modules/api/booking'
// import ApiQuote from '@/modules/api/quote'
import currencyCountry from '@/data/currency-country.js'

export default {
  name: 'flight-form',
  components: { LocationInput, TravellersModal },
  data () {
    return {
      pickup: '',
      dropoff: '',
      pickupText: '',
      dropoffText: '',
      timezoneLoading: false,
      validation: {
        pickup: '',
        dropoff: ''
      },
      quoteErrorMsg: '',
      d2dQueue: [],
      d2dValidation: {
        date: ''
      },
      d2dFlightLoading: false,
      lastPickup: '',
      lastDropoff: '',
      showOnLoad: false,
      highlight: {
        active: 'pickup',
        delay: ''
      },
      flightQuoteError: {
        leg1: 0,
        leg2: 0
      },
      groundQuoteError: {
        pickup: '',
        dropoff: ''
      },
      quickQuoteCheck: false,
      flightEnable: false,
      widgetErrorRemover: ''
    }
  },
  computed: {
    user () { return this.$store.state.user },
    booking () { return this.$store.state.booking },
    airlines () { return this.booking.airlines },
    filters () { return this.booking.filters },
    locations () { return this.booking.locations },
    isReturning () { return this.filters.departure.isReturning },
    hideGround () { return this.booking.hideGround },
    pickupExtra () {
      return {
        field: 'pickup',
        placeholder: 'Enter your pickup location e.g. Home, Office address',
        type: 'd2d'
      }
    },
    dropoffExtra () {
      return {
        field: 'dropoff',
        placeholder: 'Enter your dropoff location e.g. Home, Office address', // e.g. Home, Hotel etc.
        error: this.validation.dropoff,
        type: 'd2d'
      }
    },
    buttonLoading () { return this.timezoneLoading },
    d2dEnabled () { return CONFIG.featureToggle.d2dBooking },
    departureDate () {
      let date1 = moment(this.filters.departure.date, 'MM/DD/YYYY').format('MMM DD')
      if (this.filters.departure.isReturning) {
        let date2 = moment(this.filters.departure.return, 'MM/DD/YYYY').format('MMM DD')
        return `${date1} - ${date2}`
      }
      return date1
    },
    _brandId () { return this.$store.state.brandId },
    other () { return this.$store.state.other },
    currencyStore () { return this.other.currency },
    _pickup () { return this.locations.pickup.title },
    _dropoff () { return this.locations.dropoff.title },
    rsvpData () { return this.$store.state.reservation },
    mtech () { return this.rsvpData.mtech }
  },
  methods: {
    locationNewValue (value) {
      let self = this
      if (value.fromMap && !value.keyInput.trim()) return

      if (value.field === 'pickup') {
        self.pickupText = value.keyInput
        this.$emit('pickupChange')
        if (value.keyInput.trim() === '') {
          self.$store.commit('booking/setLocationsData', {pickup: {}})
        } else {
          if (!value.blurStop) {
            this.validation.pickup = ''
            this.$refs.dropoff.focus()
          }
        }
      } else {
        self.dropoffText = value.keyInput
        if (value.keyInput.trim() === '') {
          self.$store.commit('booking/setLocationsData', {dropoff: {}})
        } else {
          this.validation.dropoff = ''
        }
      }

      if (value.keyInput && value.check) {
        let tmpObj = {}
        tmpObj[value.field] = value.isAirport
        self.$store.commit('booking/setHideGround', tmpObj)

        if (self.pickupText && self.dropoffText) {
          setTimeout(() => {
            self.$nextTick().then(() => {
              self.$forceUpdate()
              self.checkGroundQuote('check', {})
            })
          }, 250)
        }
      }
    },
    triggerClickSubmit () {
      if (this.$refs.quoteBtn) this.$refs.quoteBtn.click()
    },
    reverseLoc () {
      if (this.quickQuoteCheck) return
      let pickup = Object.assign({}, this.locations.pickup)
      let dropoff = Object.assign({}, this.locations.dropoff)

      this.dropoffText = pickup.title
      this.pickupText = dropoff.title
      this.dropoff = pickup.title
      this.pickup = dropoff.title
      this.$store.commit('booking/setLocationsData', {
        pickup: dropoff,
        dropoff: pickup
      })
      this.$store.commit('airports/sortList', { lat: dropoff.lat, lng: dropoff.lng })
      this.$emit('pickupChange')
    },
    openDeparturePicker () {
      this.$store.commit('booking/setDepartureData', {show: true})
    },
    openTravellersModal () {
      this.$store.commit('booking/setTravellersData', {show: true})
    },
    submit (event = null) {
      if (event) event.preventDefault()
      if (this.quickQuoteCheck) return
      // validator
      let self = this

      self.validation.pickup = ''
      self.validation.dropoff = ''
      let hasError = false
      if (self.pickupText.trim() === '') {
        hasError = true
        self.validation.pickup = self.$t('common.fieldEmpty')
      } else if ((typeof self.locations.pickup === 'object' && !Object.keys(self.locations.pickup).length) || !self.locations.pickup) {
        hasError = true
        self.validation.pickup = 'Please select location'
      }
      if (self.dropoffText.trim() === '') {
        hasError = true
        self.validation.dropoff = self.$t('common.fieldEmpty')
      } else if ((typeof self.locations.dropoff === 'object' && !Object.keys(self.locations.dropoff).length) || !self.locations.dropoff) {
        hasError = true
        self.validation.dropoff = 'Please select location'
      }
      if (!self.filters.departure.date) {
        hasError = true
        self.d2dValidation.date = self.$t('common.fieldEmpty')
      }

      if (!!self.validation.pickup && this.highlight.active === 'pickup') this.highlight.active = ''
      if (!!self.validation.dropoff && this.highlight.active === 'dropoff') this.highlight.active = ''

      if (hasError) {
        return
      }

      // if (self.locations.isAirportPickup || self.locations.isAirportDropoff) {
      //   let type = self.locations.isAirportPickup ? 'pick-up' : 'drop-off'
      //   self.$store.commit('global/setAlertData', {show: true, message: `Please provide your ${type} address for our Door2door flight service. We will pick you up from your location.`})
      //   return
      // }

      if (window.gtag) { // eslint-disable-line
        gtag('event', 'Flight Booking - Search') // eslint-disable-line
      }

      self.$store.commit('other/setOtherData', {
        appLoader: true,
        appLoaderMsg: ''
      })

      // Reset Quote Errors
      self.flightQuoteError = {leg1: 0, leg2: 0}
      self.groundQuoteError = {pickup: '', dropoff: ''}

      let widgetType = self.locations.isAirportPickup && self.locations.isAirportDropoff ? 'flight' : 'd2d'
      self.$store.commit('other/setOtherData', {widgetTab: widgetType})

      self.d2dQueue = []
      // 'checkPickupDropoffDistance'
      self.d2dQueue = ['getAirports', 'pickupNearestAirport', 'dropoffNearestAirport']
      if (!localStorage.getItem('firstVisitData') && !self.user.token && self.booking.settings.requirePhone) self.d2dQueue.push('getMobile')
      else self.d2dQueue.push('getFlight')
      self.d2dProcess()
    },
    d2dProcess () {
      let self = this
      if (!self.d2dQueue.length) return
      if (self.d2dQueue[0] === 'checkPickupDropoffDistance') {
        self.$store.commit('other/setOtherData', {appLoaderMsg: 'Checking Locations...'})
        self.checkGroundQuote('check', {})
        return
      }
      if (self.d2dQueue[0] === 'getAirports') {
        self.$store.commit('other/setOtherData', {appLoaderMsg: 'Getting airport data...'})
        self.getAirportList()
        return
      }
      if (self.d2dQueue[0] === 'pickupNearestAirport') {
        self.$store.commit('other/setOtherData', {appLoaderMsg: 'Searching for nearby Airport...'})
        self.checkNearestAirport('pickup')
        return
      }
      if (self.d2dQueue[0] === 'dropoffNearestAirport') {
        self.$store.commit('other/setOtherData', {appLoaderMsg: 'Searching for nearby Airport...'})
        self.checkNearestAirport('dropoff')
        return
      }
      if (self.d2dQueue[0] === 'getFlight') {
        self.$store.commit('other/setOtherData', {
          appLoaderMsg: 'Don’t close now—your perfect deal is loading! This only takes up to a minute.',
          useLoadingMsg: true
        })
        let leg1 = [...self.booking.cabinList]
        let tmp = {loading: [], selectedCabin: 'Economy'}
        self.$store.commit('booking/setAirlinesLegData', {leg: 'leg1', fields: tmp})
        leg1.forEach(cabin => {
          self.getFlightQuote(cabin, 'leg1')
          if (self.isReturning) self.getFlightQuote(cabin, 'leg2')
        })
      }
      if (self.d2dQueue[0] === 'getMobile') {
        self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
        self.$store.commit('user/setFirstVisitData', {
          show: true,
          source: 'flight'
        })
      }
    },
    getAirportList () {
      let self = this
      if (self.booking.airports.length) {
        self.d2dQueue.shift()
        self.d2dProcess()
        return
      }

      self.$sdk.get(self, '/airport', {}, r => {
        let airports = []
        if (r.list) {
          r.list.forEach(data => {
            airports.push({
              name: data.name,
              code: data.code,
              address1: data.addressLine1,
              address2: data.addressLine2,
              city: data.city,
              state: data.state,
              zip: data.zipCode,
              country: data.country,
              lat: data.lat,
              lng: data.lng
            })
          })
        }
        self.$store.commit('booking/setAirportData', {airports: airports})
        setTimeout(function () {
          self.d2dQueue.shift()
          self.d2dProcess()
        }, 200)
      }, '2.0')
    },
    checkNearestAirport (type) {
      let self = this
      let loc = self.locations[type]
      let coord1 = {
        lat: loc.lat,
        lng: loc.lng
      }
      let nearest = {
        airport: {},
        distance: ''
      }
      let tmpList = []
      self.booking.airports.forEach((x, i) => {
        let currentDistance = self.getDistance(coord1, {lat: x.lat, lng: x.lng})
        if (!nearest.distance) {
          nearest.airport = self.booking.airports[i]
          nearest.distance = currentDistance
        } else if (currentDistance < nearest.distance) {
          nearest.airport = self.booking.airports[i]
          nearest.distance = currentDistance
        }
        if (currentDistance <= self.booking.settings.nearByAirportMilesLimit) {
          tmpList.push({
            airport: self.booking.airports[i],
            distance: currentDistance
          })
        }
      })
      tmpList.sort((a, b) => {
        return a.distance - b.distance
      })
      let tmp = {}
      tmp[type] = tmpList
      self.$store.commit('booking/setNearyByAirports', tmp)
      if (!tmpList.length) {
        trackError.track(self, {
          type: 'no_nearby_airport',
          data: {
            main_pickup: self.locations.pickup,
            main_dropoff: self.locations.dropoff,
            request: '',
            response: '',
            target: loc,
            D2DAirportDistanceLimitMiles: self.booking.settings.nearByAirportMilesLimit
          }
        })
        self.d2dQueue = []
        self.$store.commit('global/setAlertData', {show: true, message: `Out of Coverage Area, We're working hard to cover your pickup/drop-off location soon.`})
        self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
        return
      }

      let data = {}
      data[`${type}Airport`] = nearest.airport
      let reverseType = type === 'pickup' ? 'dropoff' : 'pickup'
      data[`${reverseType}AirportReturn`] = nearest.airport
      self.$store.commit('booking/setLocationsData', data)
      let tmpLoc = {}
      tmpLoc[type] = nearest.airport
      self.$store.commit('booking/setFlightLocationsData', tmpLoc)
      self.checkGroundQuote(type, data[`${type}Airport`])

      if (type === 'pickup' && CONFIG.featureToggle.quoteReroute) {
        // Set Locations
        self.$store.commit('reservation/setPickup', {leg: 'leg1', value: self.locations.pickup})
        self.$store.commit('reservation/setDropoff', {leg: 'leg1', value: nearest.airport})
        self.$store.commit('reservation/setIsAirportPickup', {leg: 'leg2', value: true})
        // Set Date
        self.$store.commit('reservation/setIsAsap', {leg: 'leg1', value: false})
        let timeNow = moment()
        let div5 = timeNow.minutes() % 5
        timeNow = timeNow.subtract(div5, 'minutes')
        self.$store.commit('reservation/setPickupDate', {leg: 'leg1', value: `${self.filters.departure.date} ${timeNow.format('hh:mmA')}`})
        self.$store.commit('serviceSelection/setForPickupDate', false)
      }
    },
    checkGroundQuote (type, airport) {
      let self = this

      if (self.other.widgetTab === 'flight') {
        self.d2dQueue.shift()
        self.d2dProcess()
        return
      }
      if (self.quickQuoteCheck) return
      self.quickQuoteCheck = true

      let pickupDate = moment(self.filters.departure.date, 'MM/DD/YYYY').format('YYYY-MM-DD')
      let quoteData = {
        pickupDate: pickupDate,
        leg: 'leg1',
        brandId: self.$store.state.brandId,
        order: 'priority',
        asap: false,
        d2dflight: 1
      }
      let origin = type === 'pickup' ? self.locations.pickup : airport
      let destination = type === 'pickup' ? airport : self.locations.dropoff
      if (type === 'check') {
        origin = self.locations.pickup
        destination = self.locations.dropoff
        if (origin.lat === destination.lat && origin.lng === destination.lng) {
          self.quickQuoteCheck = false
          self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
          self.$store.commit('global/setAlertData', {show: true, message: 'Please select a different location.'})
          return
        }
      }
      quoteData.pickup = {
        lat: origin.lat,
        lng: origin.lng
      }
      quoteData.dropoff = {
        lat: destination.lat,
        lng: destination.lng
      }
      let timeNow = moment()
      if (origin.country === 'IND') {
        quoteData.pickup.text = origin.title || origin.name
        quoteData.dropoff.text = destination.title || destination.name
        quoteData.pickupTimestamp = moment(self.filters.departure.date, 'MM/DD/YYYY').format('X')
        quoteData.dynamicTime = false
        quoteData.tripType = 1
      }
      self.$sdk.post(self, '/quotation', quoteData, r => {
        self.sendQuoteTime(timeNow, moment(), r.quoteId, quoteData)
        self.quickQuoteCheck = false
        if (r.error && type !== 'check') {
          let msg = 'Out of Coverage Area, We\'re working hard to cover your pickup/drop-off location soon.'
          if (CONFIG.featureToggle.quoteReroute) {
            self.groundQuoteError[type] = msg
            self.d2dQueue.shift()
            self.d2dProcess()
            return
          }
          self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
          self.$store.commit('global/setAlertData', {show: true, message: msg})
          trackError.track(self, {
            type: 'ground_booking',
            data: {
              main_pickup: self.locations.pickup,
              main_dropoff: self.locations.dropoff,
              request: {
                route: '/quotation',
                payload: quoteData
              },
              response: r
            }
          })
          return
        }
        if (r.error && type === 'check') {
          self.flightEnable = true
          return
        }
        if (!r.error) {
          if (type === 'check') {
            if (r.route.distance <= self.booking.settings.forceGroundMiles) {
              self.flightEnable = false
              self.$store.commit('reservation/setPickup', {leg: 'leg1', value: self.locations.pickup})
              self.$store.commit('reservation/setDropoff', {leg: 'leg1', value: self.locations.dropoff})
              self.$store.commit('reservation/setIsAirportPickup', {leg: 'leg1', value: false})
              self.$store.commit('reservation/setIsAirportDropoff', {leg: 'leg1', value: false})
              self.$store.commit('reservation/setIsAsap', { leg: 'leg1', value: false })
              let timeNow = moment()
              let div5 = timeNow.minutes() % 5
              timeNow = timeNow.subtract(div5, 'minutes')
              self.$store.commit('reservation/setPickupDate', { leg: 'leg1', value: `${self.filters.departure.date} ${timeNow.format('hh:mmA')}` })
              self.$store.commit('serviceSelection/setForPickupDate', false)
              let roundttrip = self.filters.departure.isReturning
              self.$store.commit('reservation/setIsRoundtrip', roundttrip)
              if (roundttrip) {
                self.$store.commit('reservation/setRtPricing', true)
                self.$store.commit('reservation/setIsAirportPickup', {leg: 'leg2', value: false})
                self.$store.commit('reservation/setIsAirportDropoff', {leg: 'leg2', value: false})
                self.$store.commit('reservation/setPickupDate', { leg: 'leg2', value: `${self.filters.departure.return} ${timeNow.format('hh:mmA')}` })
              }
              self.$emit('forceGround')
              return
            }
            self.quickQuoteCheck = false
            self.flightEnable = true
            return
          }

          if ((!r.services.length && !r.mtech) || (r.mtech && !r.mtech.services.length)) {
            let msg = self.$t('searchForm.noAvailableService')
            if (CONFIG.featureToggle.quoteReroute) {
              self.groundQuoteError[type] = msg
              self.d2dQueue.shift()
              self.d2dProcess()
              return
            }
            self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
            self.$store.commit('global/setAlertData', {show: true, message: msg})
            trackError.track(self, {
              type: 'ground_booking',
              data: {
                main_pickup: self.locations.pickup,
                main_dropoff: self.locations.dropoff,
                request: {
                  route: '/quotation',
                  payload: quoteData
                },
                response: r
              }
            })
            return
          }

          // if (type === 'pickup' && CONFIG.featureToggle.quoteReroute) {
          //   ApiQuote.getQuote2(self, quoteData, res => {
          //     self.$store.commit('reservation/resetServiceEta')
          //     let serviceExist = false
          //     for (let service in res.services) {
          //       let serviceData = res.services[service]
          //       if (parseInt(self.rsvpData.leg1.selectedService.substr(1)) === serviceData.serviceType.id && !serviceData.unavailableTime) {
          //         serviceExist = true
          //       }
          //     }
          //     if (!serviceExist) {
          //       self.$store.commit('reservation/setSelectedService', {leg: 'leg1', value: ''})
          //     }
          //     if (self.mtech.enabled && self.rsvpData.leg1.selectedService) {
          //       self.getQuoteMtechService()
          //     } else {
          //       self.$store.commit('other/setOtherData', {widgetTab: 'ground'})
          //       self.proceedToService(true)
          //     }
          //   })
          // }
        }
        self.d2dQueue.shift()
        self.d2dProcess()
      }, '2.0')
    },
    getDistance (coord1, coord2) {
      let toRad = value => value * Math.PI / 180
      let R = 6371
      let latD = toRad(coord2.lat - coord1.lat)
      let longD = toRad(coord2.lng - coord1.lng)
      let a = Math.sin(latD / 2) * Math.sin(latD / 2) +
        Math.cos(toRad(coord1.lat)) * Math.cos(toRad(coord2.lat)) *
        Math.sin(longD / 2) * Math.sin(longD / 2)
      let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      let distance = R * c
      return distance / 1.609344
    },
    getFlightQuote (cabin, leg) {
      let self = this
      if (self.booking.airlines[leg].loading.indexOf(cabin) > -1) return
      self.$store.commit('booking/toggleAirlinesLoading', {leg: leg, val: cabin})

      // Reset Airlines Data - By Cabin
      booking.resetAirlineData(self, cabin, leg)

      let params = booking.flightParam(self, cabin, leg)
      self.$sdk.post2(`${CONFIG.d2dAPI}/flight`, params, r => {
        try {
          if (r === null || !Object.keys(r).length || r.code === 'ETIMEDOUT' || r.error === 'No flight data found in the response.') {
            self.flightQuoteError[leg] = 3
            // self.$store.commit('global/setAlertData', {show: true, message: 'No flights found for the specified location. Please try again later or verify the location entered.'})
            trackError.track(self, {
              type: 'flight_booking',
              data: {
                main_pickup: self.locations.pickup,
                main_dropoff: self.locations.dropoff,
                request: {
                  url: `${CONFIG.d2dAPI}/flight`,
                  payload: params
                },
                response: r
              }
            })
            self.$store.commit('booking/toggleAirlinesLoading', {leg: leg, val: cabin})
            self.flightQuoteDone(cabin, leg)
            return
          }

          if (r.code === 'ERR_BAD_RESPONSE') {
            if (self.flightQuoteError[leg] < 2) self.flightQuoteError[leg] = 2
            // self.$store.commit('global/setAlertData', {show: true, message: `Oops! Something went wrong. Please try again later. `})
            trackError.track(self, {
              type: 'flight_booking',
              data: {
                main_pickup: self.locations.pickup,
                main_dropoff: self.locations.dropoff,
                request: {
                  url: `${CONFIG.d2dAPI}/flight`,
                  payload: params
                },
                response: r
              }
            })
            self.$store.commit('booking/toggleAirlinesLoading', {leg: leg, val: cabin})
            self.flightQuoteDone(cabin, leg)
            return
          }

          let tmpStoredData = {leg: leg, fields: {}}
          tmpStoredData.fields[cabin] = r
          self.$store.commit('global/setStoredFlightData', tmpStoredData)

          if (r.FlightDataList && r.FlightDataList.JourneyList && r.FlightDataList.JourneyList[0]) {
            let flightData = booking.buildFlightData(self, r, cabin, leg)

            // Save Flight List
            let tmpAirlineLegData = {leg: leg, fields: {}}
            tmpAirlineLegData.fields[cabin] = flightData.flights
            self.$store.commit('booking/setAirlinesLegData', tmpAirlineLegData)

            // Save Airline Unique
            let tmpAirlineUnique = {}
            tmpAirlineUnique[cabin] = flightData.airlinesUnique
            self.$store.commit('booking/setAirlinesUniqueLegData', {
              leg: leg,
              fields: tmpAirlineUnique
            })

            let tmpApplyFilter = {leg: leg, fields: {}}
            tmpApplyFilter.fields[cabin] = true
            self.$store.commit('booking/setApplyFilter', tmpApplyFilter)

            self.setupPax()
            localStorage.removeItem('lastPickupLoc')
            localStorage.removeItem('lastDropoffLoc')
            localStorage.setItem('lastPickupLoc', JSON.stringify(self.locations.pickup))
            localStorage.setItem('lastDropoffLoc', JSON.stringify(self.locations.dropoff))
            if (Object.keys(self.locations.pickup).indexOf('isAirport') > -1) localStorage.setItem('fixLastPickupLoc', true)
            if (Object.keys(self.locations.dropoff).indexOf('isAirport') > -1) localStorage.setItem('fixLastDropoffLoc', true)
            self.$store.commit('reservation/setOtherData', {bookingType: 'flight'})
            self.$store.commit('booking/setOthersData', {activeLeg: 'leg1'})
            self.$store.commit('booking/toggleAirlinesLoading', {leg: leg, val: cabin})
            self.flightQuoteDone(cabin, leg)
          }
        } catch (error) {
          if (self.flightQuoteError[leg] < 1) self.flightQuoteError[leg] = 1
          // self.$store.commit('global/setAlertData', {show: true, message: 'Something went wrong. Please adjust your search and try again.'})
          trackError.track(self, {
            type: 'flight_booking',
            data: {
              main_pickup: self.locations.pickup,
              main_dropoff: self.locations.dropoff,
              request: {
                url: `${CONFIG.d2dAPI}/flight`,
                payload: params
              },
              response: '',
              console_error: error
            }
          })
          self.$store.commit('booking/toggleAirlinesLoading', {leg: leg, val: cabin})
          self.flightQuoteDone(cabin, leg)
        }
      })
    },
    setupPax () {
      let paxForm = { adult: [], children: [], infants: [] }
      let paxFields = {
        title: '',
        gender: '',
        firstName: '',
        middleName: '',
        lastName: '',
        suffix: '',
        mobile: '',
        email: '',
        bday: '',
        birthDay: '',
        birthMonth: '',
        birthYear: '',
        passport: '',
        address: '',
        city: '',
        zip: '',
        country: '',
        countryCode: ''
      }
      let defaultAdded = false
      for (let x = 0; x < this.filters.travellers.adult; x++) {
        let tmpObj = {}
        Object.keys(paxFields).forEach(f => {
          tmpObj[`${f}${x}`] = paxFields[f]
        })
        if (this.user.token && x === 0 && !defaultAdded) {
          tmpObj.firstName0 = this.user.firstName
          tmpObj.lastName0 = this.user.lastName
          tmpObj.email0 = this.user.email
          tmpObj.mobile0 = this.user.phone.number
          tmpObj.countryCode0 = this.user.phone.code
          if (this.user.bday) {
            let dob = moment(this.user.bday, 'YYYY-MM-DD')
            tmpObj.birthDay0 = dob.format('DD')
            tmpObj.birthMonth0 = dob.format('MM')
            tmpObj.birthYear0 = dob.format('YYYY')
          }
          if (this.user.address) tmpObj.address0 = this.user.address
          if (this.user.city) tmpObj.city0 = this.user.city
          if (this.user.zip) tmpObj.zip0 = this.user.zip
          if (this.user.country) tmpObj.country0 = this.user.country
          if (this.user.passportNum) tmpObj.passport0 = this.user.passportNum
          defaultAdded = true
        }
        paxForm.adult.push(tmpObj)
      }
      for (let x = 0; x < this.filters.travellers.children; x++) {
        let tmpObj = {}
        Object.keys(paxFields).forEach(f => {
          tmpObj[`${f}${x}`] = paxFields[f]
        })
        paxForm.children.push(tmpObj)
      }
      for (let x = 0; x < this.filters.travellers.infants; x++) {
        let tmpObj = {}
        Object.keys(paxFields).forEach(f => {
          tmpObj[`${f}${x}`] = paxFields[f]
        })
        paxForm.infants.push(tmpObj)
      }
      this.$store.commit('booking/clearTravellerInfo')
      this.$store.commit('booking/addTravellerInfo', paxForm)
    },
    checkShowOnLoad () {
      if (!this._brandId) { return }
      let brandData = Object.values(CONFIG.Brands).find((v) => {
        return parseInt(this._brandId, 10) === parseInt(v.id, 10)
      }) || false
      let firstPage = ['Search', 'SearchEdit', 'SearchTrack']
      document.body.classList.remove('widget-full')
      if (brandData) {
        this.showOnLoad = brandData.showOnLoad && firstPage.indexOf(this.route) > -1 ? 'show-on-load' : ''
      }
      if (!this.showOnLoad) {
        this.$refs.pickup.focus()
      }
    },
    nextHighlight () {
      if (!this.pickupText && !this.validation.pickup) this.highlight.active = 'pickup'
      else if ((this.highlight.active === 'pickup' || !this.dropoffText) && !this.validation.dropoff) this.highlight.active = 'dropoff'
      else if (this.highlight.active === 'dropoff') this.highlight.active = 'date'
      else if (this.highlight.active === 'date') this.highlight.active = 'pax'
      else if (this.highlight.active === 'pax') this.highlight.active = 'search'
    },
    continueBooking () {
      this.d2dQueue = ['getFlight']
      this.d2dProcess()
    },
    sendQuoteTime (start, end, quoteId, param) {
      let self = this
      let store = self.$store.state
      let duration = end.diff(start, 'milliseconds') / 1000
      self.$sdk.opt('/quotation/time', {
        token: store.user.token,
        brandId: store.brandId,
        quotationId: quoteId,
        responseTime: duration,
        deviceType: 'ww',
        data: JSON.stringify(param)
      }, res => {
        if (res.error) console.log('ERROR quotation time')
      })
    },
    flightQuoteDone (cabin, leg) {
      let self = this
      let airline = self.airlines[leg]
      let pass = {leg1: false, leg2: false}

      /*
        Check if selected cabin is done loading and not empty
        else check other airlines and change selected
      */

      if (airline.loading.indexOf(airline.selectedCabin) === -1) {
        pass[leg] = airline[airline.selectedCabin].length > 0
        if (!pass[leg]) {
          let cabins = [...self.booking.cabinList]
          let tmpLoading = [...airline.loading]
          let doneCabin = cabins.filter(x => { return tmpLoading.indexOf(x) === -1 })
          let hasChosen = false
          doneCabin.forEach(x => {
            if (!hasChosen && airline[x].length) {
              hasChosen = true
              self.$store.commit('booking/setAirlinesLegData', {
                leg: leg,
                fields: {selectedCabin: x}
              })
              pass[leg] = true
            }
          })
        }
      }

      let otherLeg = leg === 'leg1' ? 'leg2' : 'leg1'
      let airline2 = self.airlines[otherLeg]
      if (self.isReturning && airline2.loading.indexOf(airline2.selectedCabin) === -1) {
        pass[otherLeg] = airline2[airline2.selectedCabin].length > 0
        if (!pass[otherLeg]) {
          let cabins = [...self.booking.cabinList]
          let tmpLoading = [...airline2.loading]
          let doneCabin = cabins.filter(x => { return tmpLoading.indexOf(x) === -1 })
          let hasChosen = false
          doneCabin.forEach(x => {
            if (!hasChosen && airline2[x].length) {
              hasChosen = true
              self.$store.commit('booking/setAirlinesLegData', {
                leg: otherLeg,
                fields: {selectedCabin: x}
              })
              pass[otherLeg] = true
            }
          })
        }
      }

      // if any of the Ground quotation fails and flight is available switch to FLIGHT mode
      if (
        CONFIG.featureToggle.quoteReroute &&
        (self.groundQuoteError.pickup || self.groundQuoteError.dropoff) &&
        pass.leg1 && ((self.isReturning && pass.leg2) || !self.isReturning)
      ) {
        self.$store.commit('other/setOtherData', {widgetTab: 'flight'})
        self.proceedToService()
        return
      }

      if (
        (!pass.leg1 || (!pass.leg2 && self.isReturning)) &&
        !airline.loading.length && !airline2.loading.length
      ) {
        if (
          CONFIG.featureToggle.quoteReroute &&
          !self.groundQuoteError.pickup && !self.groundQuoteError.dropoff
        ) {
          self.$store.commit('other/setOtherData', {widgetTab: 'ground'})
          self.proceedToService(true)
          return
        }
        let errorTier = Math.max(...[self.flightQuoteError.leg1, self.flightQuoteError.leg2])
        let errorMsg = 'No flights found. Please try again later.'
        if (errorTier === 2) errorMsg = 'Oops! Something went wrong. Please try again later.'
        if (errorTier === 1) errorMsg = 'Something went wrong. Please adjust your search and try again.'
        self.$store.commit('global/setAlertData', {show: true, message: errorMsg})
        self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
        return
      }

      if (pass.leg1 && ((self.isReturning && pass.leg2) || !self.isReturning)) {
        self.proceedToService()
      }
    },
    proceedToService (directToGround = false) {
      if (directToGround) {
        this.$store.commit('reservation/setPickup', {leg: 'leg1', value: this.locations.pickup})
        this.$store.commit('reservation/setDropoff', {leg: 'leg1', value: this.locations.dropoff})
        this.$store.commit('reservation/setIsAirportPickup', {leg: 'leg1', value: false})
        this.$store.commit('reservation/setIsAirportDropoff', {leg: 'leg1', value: true})
        this.$store.commit('reservation/setIsAsap', { leg: 'leg1', value: false })
        let timeNow = moment()
        let div5 = timeNow.minutes() % 5
        timeNow = timeNow.subtract(div5, 'minutes')
        this.$store.commit('reservation/setPickupDate', { leg: 'leg1', value: `${this.filters.departure.date} ${timeNow.format('hh:mmA')}` })
        this.$store.commit('serviceSelection/setForPickupDate', false)
        this.$store.commit('reservation/setIsRoundtrip', false)
        this.$emit('forceGround')
        // this.$router.push('service')
        return
      }

      let includedLandTranspo = []
      if (this.other.widgetTab === 'd2d' && (this.lastPickup !== this._pickup || this.lastDropoff !== this._dropoff)) {
        // Setup: Opt-in Ground Booking
        // includedLandTranspo = this.filters.departure.isReturning ? [0, 1, 2, 3] : [0, 1]
        if (!this.hideGround.pickup) includedLandTranspo.push(0)
        if (!this.hideGround.dropoff) includedLandTranspo.push(1)
        if (this.filters.departure.isReturning) {
          if (!this.hideGround.dropoff) includedLandTranspo.push(2)
          if (!this.hideGround.pickup) includedLandTranspo.push(3)
        }
      }
      this.$store.commit('booking/setOthersData', {includedLandTranspo: includedLandTranspo})

      document.body.classList.add('widget-full', 'd2d-mode')
      this.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
      this.$router.push('d2dservice')
    },
    getQuoteMtechService () {
      let self = this
      let rsvpData = this.rsvpData.leg1

      let pickupDate = rsvpData.flightDate || rsvpData.pickupDate
      pickupDate = pickupDate || moment().format('MM/DD/YYYY hh:mmA')
      pickupDate = moment(pickupDate, 'MM/DD/YYYY hh:mmA')
      let quoteData = {
        asap: false,
        brandId: self._brandId,
        leg: 'leg1',
        pickupDate: pickupDate.format('YYYY-MM-DD'),
        pickupTime: pickupDate.format('HH:mm:ss'),
        pickup: rsvpData.pickup,
        dropoff: rsvpData.dropoff,
        order: 'priority',
        passengers: rsvpData.passenger,
        mtechServiceType: rsvpData.selectedService
      }
      quoteData.pickup.text = quoteData.pickup.title
      quoteData.dropoff.text = quoteData.dropoff.title
      if (rsvpData.flightDate) {
        quoteData.pickupTimestamp = moment.tz(rsvpData.flightDate, 'MM/DD/YYYY hh:mmA', rsvpData.timezone).format('X')
      } else {
        quoteData.pickupTimestamp = moment.tz(`${quoteData.pickupDate} ${quoteData.pickupTime}`, 'YYYY-MM-DD HH:mm', rsvpData.timezone).format('X')
      }

      self.$store.commit('reservation/setServiceLoading', true)
      let timeNow = moment()
      self.$sdk.post(self, '/quotation', quoteData, res => {
        self.sendQuoteTime(timeNow, moment(), res.quoteId, quoteData)
        self.$store.commit('reservation/setServiceLoading', false)
        if (!res.error) {
          self.$store.commit('reservation/setQuoteId', res.quoteId)
          if (res.mtech.services.length) {
            let mtech = res.mtech
            let mtechStore = self.rsvpData.mtech
            let service = res.mtech.services[0]
            let price = service.price

            let hasDiscount = false
            let discountVal = 0
            let totalBeforeDc = 0
            let baseFare = price.amount
            service.price.breakdown.forEach(x => {
              if (x.description === 'Base rate') {
                baseFare = x.amount
              }
              if (x.description === 'Discount') {
                hasDiscount = true
                discountVal = x.amount
              }
              if (x.amount > 0) {
                totalBeforeDc += x.amount
              }
            })

            let addMarkup = 0
            if (mtech.markup.value) {
              addMarkup = mtechStore.markup.value
              if (mtech.markup.type === '%') {
                addMarkup = baseFare * (mtech.markup.value / 100)
              }
              addMarkup = parseFloat(addMarkup.toFixed(2))
            }

            self.$store.commit('reservation/setMtechNewPricing', {
              code: rsvpData.selectedService,
              val: {
                baseFare: baseFare,
                amount: price.amount,
                addMarkup: addMarkup,
                breakdown: price.breakdown,
                hasDiscount: hasDiscount,
                discountVal: Math.abs(discountVal),
                totalBeforeDc: totalBeforeDc
              }
            })
          }
          self.$nextTick().then(() => {
            self.$forceUpdate()
          })
          self.$store.commit('other/setOtherData', {widgetTab: 'ground'})
          self.proceedToService(true)
        }
      }, '2.0')
    }
  },
  watch: {
    _pickup: function (value) {
      this.pickupText = value
      this.$emit('pickupChange')
    },
    _dropoff: function (value) {
      this.dropoffText = value
      this.$emit('dropoffChange')
    },
    _brandId: function () {
      this.checkShowOnLoad()
    },
    departureDate (val) {
      this.nextHighlight()
    },
    'filters.travellers.total': function (val) {
      this.nextHighlight()
    }
  },
  mounted () {
    let locations = this.locations
    if (this.other.widgetTab === 'flight' && this.locations.flight.pickup.title) locations = this.locations.flight
    if (locations.pickup.title) {
      this.pickup = locations.pickup.title
      this.pickupText = locations.pickup.title
      this.dropoff = locations.dropoff.title
      this.dropoffText = locations.dropoff.title
    }

    let self = this
    if ("geolocation" in navigator) {
      if (self._pickup) return
      navigator.geolocation.getCurrentPosition(pos => {
        // self.getFlightNearestAirport(pos.coords)
        let url = 'https://revgeocode.search.hereapi.com/v1/revgeocode?at={LAT}%2C{LNG}&apiKey={API_KEY}&lang=en-US&show=countryInfo'
        url = url.replace('{LAT}', pos.coords.latitude)
          .replace('{LNG}', pos.coords.longitude)
          .replace('{API_KEY}', CONFIG.hereApi.key)
        request.get({
          url: url,
          json: true
        }, function (err, res, body) {
          self.widgetErrorRemover = err
          self.widgetErrorRemover = res
          if (body && body.items && body.items.length) {
            let result = body.items[0]
            let finalResult = {
              title: result.title,
              address1: result.address.street || result.title,
              address2: result.address.houseNumber || result.address.district,
              city: result.address.city,
              state: result.address.state,
              zip: result.address.postalCode,
              country: result.address.countryCode,
              lat: result.position.lat,
              lng: result.position.lng
            }
            let isAirport = false
            if (body.categories) {
              body.categories.forEach(cat => {
                if (cat.name && cat.name.toLowerCase().indexOf('airport') > -1) isAirport = true
              })
            }
            finalResult.isAirport = isAirport

            let tmpObj = {pickup: ''}
            tmpObj.pickup = finalResult
            self.$store.commit('booking/setLocationsData', tmpObj)
            self.pickup = finalResult.title
            self.pickupText = finalResult.title

            if (!localStorage.getItem('widgetCurrency')) {
              let currCountry = currencyCountry.find(x => x.countryCode === result.countryInfo.alpha2)
              if (currCountry) {
                if (['INR', 'CAD', 'EUR', 'GBP', 'JPY', 'CNY', 'AUD', 'AED', 'MXN', 'PHP'].indexOf(currCountry.currencyCode) > -1) {
                  self.currency = currCountry.currencyCode
                }
              }
            }

            if (result.countryInfo && result.countryInfo.alpha2) {
              self.$store.commit('other/setDefaultData', {country: result.countryInfo.alpha2})
            }
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.field-group{
  &.active{
    outline: 2px solid #ff9c09;
  }
}
.search-field-box{
  gap: 7px;
  margin-bottom: 20px;
  padding: 0;

  .field-group.full-width{
    width: 100%;
    max-width: 390px;

    &.add-limit{
      max-width: none;
    }
  }
  .date-input{
    min-width: 160px;
  }
  .field-text{
    margin: 0;
    width: 100%;
    max-width: 160px;
    min-width: 130px;

    &.disabled{
      background: #f7f7f7;
      opacity: .7;
    }
  }
  .search-submit{
    width: 130px;
    min-width: 130px;
    text-align: center;
    margin-top: 0;

    &.active{
      outline: 2px solid #ff9c09;
    }
  }
}
.reverse-loc{
  border: 1px solid #ccc;
  height: 40px;
  line-height: 40px;
  padding:0 10px;
  background: #fff;
  &:hover{
    background: #f8f8f8;
    cursor: pointer;
  }
  &.disabled{
    opacity: .5;
    cursor: default;
  }
}

@media only screen and (max-width: 641px) {
  .search-field-box{
    flex-direction: column;

    .reverse-loc-box{
      position: relative;
      height: 1px;
      width: 100%;
    }
    .reverse-loc{
      position: absolute;
      right: 10px;
      z-index: 2;
      top: -19px;
      border: 1px solid #777;
      background: #f3f2f2;
      transform: rotate(90deg);
    }
    .field-group {
      width: 100%;
      input{
        max-width: 100%;
      }
    }
    .search-submit{
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?453404cf